// Angular modules

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { APP_INITIALIZER } from '@angular/core';
import { MaterialModule } from '@angular/material';

// 3rd-party

import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TreeModule } from 'angular-tree-component';
import { FileSelectDirective } from './file-uploader/ng2-file-uploader/directives/fileSelect.directive';
import { ImagePreviewDirective } from './file-uploader/ng2-file-uploader/directives/imgPreview.directive';
import { FileDropDirective } from './file-uploader/ng2-file-uploader/directives/fileDrop.directive';
import { FileDropComponent } from './file-uploader/ng2-file-uploader/components/fileDrop.component';
import { ProgressBarDirective } from './file-uploader/ng2-file-uploader/directives/progressBar.directive';
import { FileSizePipe } from './file-uploader/ng2-file-uploader/pipe/fileSizePipe.pipe';
import { GaugeModule } from 'angular-gauge';

// Fusion

import { ConfigService } from '../services/configuration-service/configuration.service';
import * as COMPONENTS from '../components/index';
import * as SERVICES from '../services/index';
import { CfAutocompleteServiceModule } from '../services/services-module';
import { CfAvatarServiceModule } from '../services/services-module';
import { SafePipe } from '../pipes/safe/safe.pipe';
import { CfSelectableComponent } from '../components/index';
import { CfCoreGalleryHelperService } from './gallery/core-gallery/cf-core-gallery-helper.service';
import { RouterModule } from '@angular/router';
export class CfSafePipeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
  ],
  declarations: [
    SafePipe
  ],
  entryComponents: [],
  providers: [],
  exports: [SafePipe],
  schemas: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfSafePipeModule_tsickle_Closure_declarations() {
/** @type {?} */
CfSafePipeModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSafePipeModule.ctorParameters;
}

export class CfCoreComponentModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ],
  declarations: [
    COMPONENTS.CfCoreComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    COMPONENTS.CfCoreComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfCoreComponentModule_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreComponentModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreComponentModule.ctorParameters;
}

export class CfNotificationModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfSafePipeModule
  ],
  declarations: [
    COMPONENTS.CfNotificationComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfNotificationComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfNotificationModule_tsickle_Closure_declarations() {
/** @type {?} */
CfNotificationModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfNotificationModule.ctorParameters;
}

export class CfIconModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfNotificationModule
  ],
  declarations: [
    COMPONENTS.CfIconComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [COMPONENTS.CfIconComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfIconModule_tsickle_Closure_declarations() {
/** @type {?} */
CfIconModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfIconModule.ctorParameters;
}

export class CfImageModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfNotificationModule
  ],
  declarations: [
    COMPONENTS.CfImageComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [COMPONENTS.CfImageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfImageModule_tsickle_Closure_declarations() {
/** @type {?} */
CfImageModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfImageModule.ctorParameters;
}

export class CfButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfNotificationModule
  ],
  declarations: [
    COMPONENTS.CfButtonComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfButtonComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
CfButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfButtonModule.ctorParameters;
}

export class CfMenuModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfButtonModule,
    CfNotificationModule
  ],
  declarations: [
    COMPONENTS.CfMenuComponent,
    COMPONENTS.CfMenuItemComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfMenuComponent,
    COMPONENTS.CfMenuItemComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
CfMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfMenuModule.ctorParameters;
}

export class CfButtonMenuModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfButtonModule,
    CfMenuModule,
    CfNotificationModule
  ],
  declarations: [
    COMPONENTS.CfButtonMenuComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfButtonMenuComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfButtonMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
CfButtonMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfButtonMenuModule.ctorParameters;
}

export class CfFabModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfButtonModule
  ],
  declarations: [
    COMPONENTS.CfFabComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfFabComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfFabModule_tsickle_Closure_declarations() {
/** @type {?} */
CfFabModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFabModule.ctorParameters;
}

export class CfAvatarModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfSafePipeModule,
    CfAvatarServiceModule,
    CfIconModule,
    CfImageModule
  ],
  declarations: [
    COMPONENTS.CfAvatarComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfAvatarComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAvatarModule_tsickle_Closure_declarations() {
/** @type {?} */
CfAvatarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAvatarModule.ctorParameters;
}

export class CfRatingModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule
  ],
  declarations: [
    COMPONENTS.CfRatingComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfRatingComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfRatingModule_tsickle_Closure_declarations() {
/** @type {?} */
CfRatingModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfRatingModule.ctorParameters;
}

export class CfInputModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfMenuModule,
    CfNotificationModule
  ],
  declarations: [
    COMPONENTS.CfInputComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [COMPONENTS.CfInputComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfInputModule_tsickle_Closure_declarations() {
/** @type {?} */
CfInputModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfInputModule.ctorParameters;
}

export class CfAlertModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    SERVICES.CfAlertsServiceModule,
    CfIconModule,
    ToastrModule.forRoot()
  ],
  declarations: [
    COMPONENTS.CfAlertComponent,
  ],
  entryComponents: [],
  providers: [
    SERVICES.CfAlertsService,
    ToastrService
  ],
  exports: [
    COMPONENTS.CfAlertComponent,
    ToastrModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAlertModule_tsickle_Closure_declarations() {
/** @type {?} */
CfAlertModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAlertModule.ctorParameters;
}

export class CfAlertsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfAlertModule
  ],
  declarations: [
    COMPONENTS.CfAlertsComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfAlertsComponent,
    CfAlertModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAlertsModule_tsickle_Closure_declarations() {
/** @type {?} */
CfAlertsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAlertsModule.ctorParameters;
}

export class CfSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfNotificationModule
  ],
  declarations: [
    COMPONENTS.CfSelectOptionComponent,
    COMPONENTS.CfSelectComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfSelectOptionComponent,
    COMPONENTS.CfSelectComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
CfSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSelectModule.ctorParameters;
}

export class CfSelectableModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule
  ],
  declarations: [
    COMPONENTS.CfSelectableComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfSelectableComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfSelectableModule_tsickle_Closure_declarations() {
/** @type {?} */
CfSelectableModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSelectableModule.ctorParameters;
}

export class CfRadioModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfSafePipeModule,
    CfSelectableModule
  ],
  declarations: [
    COMPONENTS.CfRadioComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfRadioComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfRadioModule_tsickle_Closure_declarations() {
/** @type {?} */
CfRadioModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfRadioModule.ctorParameters;
}

export class CfCheckboxModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfNotificationModule,
    CfSafePipeModule,
    CfSelectableModule
  ],
  declarations: [
    COMPONENTS.CfCheckboxComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfCheckboxComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfCheckboxModule_tsickle_Closure_declarations() {
/** @type {?} */
CfCheckboxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCheckboxModule.ctorParameters;
}

export class CfSwitchModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfNotificationModule,
    CfSafePipeModule,
    CfSelectableModule
  ],
  declarations: [
    COMPONENTS.CfSwitchComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfSwitchComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfSwitchModule_tsickle_Closure_declarations() {
/** @type {?} */
CfSwitchModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSwitchModule.ctorParameters;
}

export class CfItemModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfCheckboxModule,
    CfIconModule
  ],
  declarations: [
    COMPONENTS.CfItemComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfItemComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfItemModule_tsickle_Closure_declarations() {
/** @type {?} */
CfItemModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfItemModule.ctorParameters;
}

export class CfListModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfItemModule
  ],
  declarations: [
    COMPONENTS.CfListComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfListComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfListModule_tsickle_Closure_declarations() {
/** @type {?} */
CfListModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfListModule.ctorParameters;
}

export class CfGroupModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule
  ],
  declarations: [
    COMPONENTS.CfGroupComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfGroupComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfGroupModule_tsickle_Closure_declarations() {
/** @type {?} */
CfGroupModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfGroupModule.ctorParameters;
}

export class CfTabsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule
  ],
  declarations: [
    COMPONENTS.CfTabsComponent,
    COMPONENTS.CfTabsCardComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfTabsComponent,
    COMPONENTS.CfTabsCardComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfTabsModule_tsickle_Closure_declarations() {
/** @type {?} */
CfTabsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfTabsModule.ctorParameters;
}

export class CfGaugeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    GaugeModule.forRoot()
  ],
  declarations: [
    COMPONENTS.CfGaugeComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfGaugeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfGaugeModule_tsickle_Closure_declarations() {
/** @type {?} */
CfGaugeModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfGaugeModule.ctorParameters;
}

export class CfAutocompleteModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfAutocompleteServiceModule
  ],
  declarations: [
    COMPONENTS.CfAutocompleteComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfAutocompleteComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfAutocompleteModule_tsickle_Closure_declarations() {
/** @type {?} */
CfAutocompleteModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfAutocompleteModule.ctorParameters;
}

export class CfToolbarModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfMenuModule
  ],
  declarations: [
    COMPONENTS.CfToolbarComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfToolbarComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfToolbarModule_tsickle_Closure_declarations() {
/** @type {?} */
CfToolbarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfToolbarModule.ctorParameters;
}

export class CfDialogModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfButtonModule,
    CfToolbarModule
  ],
  declarations: [
    COMPONENTS.CfDialogComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfDialogModule_tsickle_Closure_declarations() {
/** @type {?} */
CfDialogModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfDialogModule.ctorParameters;
}

export class CfFileUploaderModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfButtonModule
  ],
  declarations: [
    FileSelectDirective,
    FileDropDirective,
    ImagePreviewDirective,
    ProgressBarDirective,
    FileSizePipe,
    FileDropComponent,
    COMPONENTS.CfFileUploaderComponent
  ],
  entryComponents: [],
  providers: [
    SERVICES.CfFileUploaderService
  ],
  exports: [
    COMPONENTS.CfFileUploaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfFileUploaderModule_tsickle_Closure_declarations() {
/** @type {?} */
CfFileUploaderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFileUploaderModule.ctorParameters;
}

export class CfTreeviewModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    TreeModule
  ],
  declarations: [
    COMPONENTS.CfTreeviewComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfTreeviewComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfTreeviewModule_tsickle_Closure_declarations() {
/** @type {?} */
CfTreeviewModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfTreeviewModule.ctorParameters;
}

export class CfJsonEditorModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfTreeviewModule
  ],
  declarations: [
    COMPONENTS.CfJsonEditorComponent,
    COMPONENTS.CfJsonEditorHeaderComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfJsonEditorComponent,
    COMPONENTS.CfJsonEditorHeaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfJsonEditorModule_tsickle_Closure_declarations() {
/** @type {?} */
CfJsonEditorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfJsonEditorModule.ctorParameters;
}

export class CfWizardModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfButtonModule
  ],
  declarations: [
    COMPONENTS.CfWizardBackComponent,
    COMPONENTS.CfWizardComponent,
    COMPONENTS.CfWizardFinishComponent,
    COMPONENTS.CfWizardNextComponent,
    COMPONENTS.CfWizardStepComponent,
    COMPONENTS.CfWizardFooterComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfWizardBackComponent,
    COMPONENTS.CfWizardComponent,
    COMPONENTS.CfWizardFinishComponent,
    COMPONENTS.CfWizardNextComponent,
    COMPONENTS.CfWizardStepComponent,
    COMPONENTS.CfWizardFooterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfWizardModule_tsickle_Closure_declarations() {
/** @type {?} */
CfWizardModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfWizardModule.ctorParameters;
}

export class CfChartsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    NgxChartsModule
  ],
  declarations: [
    COMPONENTS.CfAreaChartComponent,
    COMPONENTS.CfBarChartComponent,
    COMPONENTS.CfChartComponent,
    COMPONENTS.CfLineChartComponent,
    COMPONENTS.CfNumberChartComponent,
    COMPONENTS.CfPieChartComponent
  ],
  entryComponents: [],
  providers: [
    SERVICES.CfEventService
  ],
  exports: [
    COMPONENTS.CfAreaChartComponent,
    COMPONENTS.CfBarChartComponent,
    COMPONENTS.CfChartComponent,
    COMPONENTS.CfLineChartComponent,
    COMPONENTS.CfNumberChartComponent,
    COMPONENTS.CfPieChartComponent,
    NgxChartsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfChartsModule_tsickle_Closure_declarations() {
/** @type {?} */
CfChartsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfChartsModule.ctorParameters;
}

export class CfDatatableModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfIconModule,
    CfInputModule,
    NgxDatatableModule
  ],
  declarations: [
    COMPONENTS.CfDatatableColumnComponent,
    COMPONENTS.CfDatatableComponent,
    COMPONENTS.CfDatatableFilterComponent,
    COMPONENTS.CfDatatablePagerComponent,
    COMPONENTS.CfDatatableRowsExpanderComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfDatatableColumnComponent,
    COMPONENTS.CfDatatableComponent,
    COMPONENTS.CfDatatableFilterComponent,
    COMPONENTS.CfDatatablePagerComponent,
    COMPONENTS.CfDatatableRowsExpanderComponent,
    NgxDatatableModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfDatatableModule_tsickle_Closure_declarations() {
/** @type {?} */
CfDatatableModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfDatatableModule.ctorParameters;
}

export class CfGalleryModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule
  ],
  declarations: [
    COMPONENTS.CfGalleryComponent,
    COMPONENTS.CfCoreGalleryArrowsComponent,
    COMPONENTS.CfCoreGalleryComponent,
    COMPONENTS.CfCoreGalleryImageComponent,
    COMPONENTS.CfCoreGalleryPreviewComponent,
    COMPONENTS.CfCoreGalleryThumbnailsComponent
  ],
  entryComponents: [],
  providers: [
    CfCoreGalleryHelperService
  ],
  exports: [
    COMPONENTS.CfGalleryComponent,
    COMPONENTS.CfCoreGalleryArrowsComponent,
    COMPONENTS.CfCoreGalleryComponent,
    COMPONENTS.CfCoreGalleryImageComponent,
    COMPONENTS.CfCoreGalleryPreviewComponent,
    COMPONENTS.CfCoreGalleryThumbnailsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfGalleryModule_tsickle_Closure_declarations() {
/** @type {?} */
CfGalleryModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfGalleryModule.ctorParameters;
}

export class CfBreadCrumbModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    RouterModule
  ],
  declarations: [
    COMPONENTS.CfBreadCrumbComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfBreadCrumbComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfBreadCrumbModule_tsickle_Closure_declarations() {
/** @type {?} */
CfBreadCrumbModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfBreadCrumbModule.ctorParameters;
}

export class CfSidenavModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule
  ],
  declarations: [
    COMPONENTS.CfSidenavComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfSidenavComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfSidenavModule_tsickle_Closure_declarations() {
/** @type {?} */
CfSidenavModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSidenavModule.ctorParameters;
}

export class CfFormQuestionModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CfCoreComponentModule,
    CfGroupModule,    
    CfSelectableModule,
    CfSelectModule,
    CfCheckboxModule,
    CfRadioModule,
    CfSwitchModule,
    CfInputModule
  ],
  declarations: [
    COMPONENTS.CfFormQuestionComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfFormQuestionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfFormQuestionModule_tsickle_Closure_declarations() {
/** @type {?} */
CfFormQuestionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFormQuestionModule.ctorParameters;
}

export class CfGroupQuestionModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CfCoreComponentModule,
    CfFormQuestionModule
  ],
  declarations: [
    COMPONENTS.CfGroupQuestionComponent,
  ],
  entryComponents: [],
  providers: [
    SERVICES.FormQuestionControlService
  ],
  exports: [
    COMPONENTS.CfGroupQuestionComponent
   ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfGroupQuestionModule_tsickle_Closure_declarations() {
/** @type {?} */
CfGroupQuestionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfGroupQuestionModule.ctorParameters;
}

export class CfFormModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CfGroupQuestionModule,
    CfFormQuestionModule,
    CfButtonModule
  ],
  declarations: [
    COMPONENTS.CfFormComponent
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfFormComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfFormModule_tsickle_Closure_declarations() {
/** @type {?} */
CfFormModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFormModule.ctorParameters;
}

export class CfFormGroupModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    CfCoreComponentModule,
    CfFormModule
  ],
  declarations: [
    COMPONENTS.CfFormGroupComponent,
  ],
  entryComponents: [],
  providers: [],
  exports: [
    COMPONENTS.CfFormGroupComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfFormGroupModule_tsickle_Closure_declarations() {
/** @type {?} */
CfFormGroupModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfFormGroupModule.ctorParameters;
}

export class CfComponentsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CfCoreComponentModule,
    CfAlertsModule,
    CfAutocompleteModule,
    CfAvatarModule,
    CfBreadCrumbModule,
    CfButtonModule,
    CfButtonMenuModule,
    CfChartsModule,
    CfCheckboxModule,
    CfCoreComponentModule,
    CfDatatableModule,
    CfDialogModule,
    CfFabModule,
    CfFileUploaderModule,
    CfFormQuestionModule,
    CfFormModule,
    CfFormGroupModule,
    CfGalleryModule,
    CfGaugeModule,
    CfGroupModule,
    CfGroupQuestionModule,
    CfIconModule,
    CfInputModule,
    CfImageModule,
    CfItemModule,
    CfJsonEditorModule,
    CfListModule,
    CfMenuModule,
    CfNotificationModule,
    CfRadioModule,
    CfRatingModule,
    CfSafePipeModule,
    CfSelectModule,
    CfSelectableModule,
    CfSidenavModule,
    CfSwitchModule,
    CfTabsModule,
    CfToolbarModule,
    CfTreeviewModule,
    CfWizardModule
  ],
  declarations: [],
  entryComponents: [],
  providers: [],
  exports: [
    CfCoreComponentModule,
    CfAlertsModule,
    CfAutocompleteModule,
    CfAvatarModule,
    CfBreadCrumbModule,
    CfButtonModule,
    CfButtonMenuModule,
    CfChartsModule,
    CfCheckboxModule,
    CfCoreComponentModule,
    CfDatatableModule,
    CfDialogModule,
    CfFabModule,
    CfFileUploaderModule,
    CfFormQuestionModule,
    CfFormModule,
    CfFormGroupModule,
    CfGalleryModule,
    CfGaugeModule,
    CfGroupModule,
    CfGroupQuestionModule,
    CfIconModule,
    CfInputModule,
    CfImageModule,
    CfItemModule,
    CfJsonEditorModule,
    CfListModule,
    CfMenuModule,
    CfNotificationModule,
    CfRadioModule,
    CfRatingModule,
    CfSafePipeModule,
    CfSelectModule,
    CfSelectableModule,
    CfSidenavModule,
    CfSwitchModule,
    CfTabsModule,
    CfToolbarModule,
    CfTreeviewModule,
    CfWizardModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CfComponentsModule_tsickle_Closure_declarations() {
/** @type {?} */
CfComponentsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfComponentsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
